//@flow
import { replace } from "react-router-redux";
import IO from "../../../core/socket";
import type { ThunkAction } from "../../../types";
import { http } from "../../../core/Api";

type ErrorFoundAction = { type: "APP/ERROR_FOUND" };
type ToggleMenuAction = { type: "APP/TOGGLE_MENU" };
type MaskSearchAction = {
  type: "APP/MASK_SEARCH",
  data: boolean
};
type RequestMeAction = { type: "APP/REQUEST_ME" };
type RequestMeSuccessAction = { type: "APP/REQUEST_ME_SUCCESS", data: Object };
type RequestLive = { type: "APP/REQUEST_LIVE", data: Object };
type RequestMeFailureAction = { type: "APP/REQUEST_ME_FAILURE" };
type RequestMeErrorAction = { type: "APP/REQUEST_ME_ERROR" };
type LogoutAction = { type: "APP/LOGOUT" };
type NewLoginAction = { type: "APP/NEW_LOGIN" };

type RegisterMeAction = { type: "APP/REGISTER_ME" };
type RemoteLogoutAction = { type: "APP/REMOTE_LOGOUT" };

type NotificationsReqAction = { type: "APP/NOTIFICATIONS_REQUEST" };
type NotificationsReqSuccessAction = {
  type: "APP/NOTIFICATIONS_SUCCESS",
  data: Object
};
type NotificationsReqFailureAction = {
  type: "APP/NOTIFICATIONS_FAILURE",
  data: Object
};

type NotificationsHistoryReqAction = { type: "APP/NOTIFICATIONS_HISTORY_REQUEST" };
type NotificationsHistoryReqSuccessAction = {
  type: "APP/NOTIFICATIONS_HISTORY_SUCCESS",
  data: Object
};
type NotificationsHistoryReqFailureAction = {
  type: "APP/NOTIFICATIONS_HISTORY_FAILURE",
  data: Object
};

type HelmetReqAction = {
  type: "APP/HELMET_REQUEST",
  data: Object
};

type ErrorReportReqAction = { type: "APP/ERROR_REPORT_REQUEST" };
type ErrorReportReqSuccessAction = {
  type: "APP/ERROR_REPORT_SUCCESS",
  data: Object
};
type ErrorReportReqFailureAction = {
  type: "APP/ERROR_REPORT_FAILURE",
  data: Object
};

export type AppAction =
  | ErrorFoundAction
  | ErrorReportReqAction
  | ErrorReportReqFailureAction
  | ErrorReportReqSuccessAction
  | ToggleMenuAction
  | MaskSearchAction
  | RequestMeErrorAction
  | RequestMeFailureAction
  | RequestMeSuccessAction
  | RequestMeAction
  | RegisterMeAction
  | RemoteLogoutAction
  | LogoutAction
  | NewLoginAction
  | RequestLive
  | NotificationsReqAction
  | NotificationsReqSuccessAction
  | NotificationsReqFailureAction
  | NotificationsHistoryReqAction
  | NotificationsHistoryReqSuccessAction
  | NotificationsHistoryReqFailureAction
  | HelmetReqAction;

export function errorFound(): AppAction {
  return {
    type: "APP/ERROR_FOUND"
  };
}

export function newLogin(): AppAction {
  return {
    type: "APP/NEW_LOGIN"
  };
}

export function toggleMenu(): AppAction {
  return {
    type: "APP/TOGGLE_MENU"
  };
}

export function maskSearch(data: boolean): AppAction {
  return {
    type: "APP/MASK_SEARCH",
    data
  };
}

export function requestMe(): AppAction {
  return {
    type: "APP/REQUEST_ME"
  };
}

export function requestMeSuccess(data: Object): AppAction {
  return {
    type: "APP/REQUEST_ME_SUCCESS",
    data
  };
}

export function requestMeFailure(): AppAction {
  return {
    type: "APP/REQUEST_ME_FAILURE"
  };
}

export function requestLive(): AppAction {
  return {
    type: "APP/REQUEST_LIVE"
  };
}

export function requestliveSucess(data: Object): AppAction {
  return {
    type: "APP/REQUEST_LIVE_SUCCESS",
    data
  };
}

export function requestliveFailure(): AppAction {
  return {
    type: "APP/REQUEST_LIVE_FAILURE"
  };
}

export function requestMeError(): AppAction {
  return {
    type: "APP/REQUEST_ME_ERROR"
  };
}

export function logout(): AppAction {
  return {
    type: "APP/LOGOUT"
  };
}

export function registerMe(): AppAction {
  return {
    type: "APP/REGISTER_ME"
  };
}

export function notificationsRequest() {
  return {
    type: "APP/NOTIFICATIONS_REQUEST"
  };
}

export function notificationsRequestSuccess(data: Object) {
  return {
    type: "APP/NOTIFICATIONS_SUCCESS",
    data
  };
}

export function notificationsRequestFailure(data: Object) {
  return {
    type: "APP/NOTIFICATIONS_FAILURE",
    data
  };
}

export function notificationsHistoryRequest() {
  return {
    type: "APP/NOTIFICATIONS_HISTORY_REQUEST"
  };
}

export function notificationsHistoryRequestSuccess(data: Object) {
  return {
    type: "APP/NOTIFICATIONS_HISTORY_SUCCESS",
    data
  };
}

export function notificationsHistoryRequestFailure(data: Object) {
  return {
    type: "APP/NOTIFICATIONS_HISTORY_FAILURE",
    data
  };
}

export function helmetRequest(data: Object): AppAction {
  return {
    type: "APP/HELMET_REQUEST",
    data
  };
}

export function errorReportRequest() {
  return {
    type: "APP/ERROR_REPORT_REQUEST"
  };
}

export function errorReportRequestSuccess(data: Object) {
  return {
    type: "APP/ERROR_REPORT_SUCCESS",
    data
  };
}

export function cleanState() {
  return {
    type: "APP/CLEAN_STATE"
  };
}

export function errorReportRequestFailure(data: Object) {
  return {
    type: "APP/ERROR_REPORT_FAILURE",
    data
  };
}

export function doErrorReportRequest(body: Object): ThunkAction {
  return dispatch => {
    dispatch(errorReportRequest());
    http(`api/backend/v2/errorsreport`, "POST", body)
      .then(response => {
        if (response.error) {
          return dispatch(errorReportRequestFailure(response.error));
        }
        return dispatch(errorReportRequestSuccess(response));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export function doNotificationsRequest(params): ThunkAction {
  return dispatch => {
    dispatch(notificationsRequest());
    http(`api/backend/v2/newtifications?${params}`, "GET")
      .then(response => {
        if (response.error) {
          return dispatch(notificationsRequestFailure(response.error));
        }
        return dispatch(notificationsRequestSuccess(response));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export function doNotificationsHistoryRequest(): ThunkAction {
  return dispatch => {
    dispatch(notificationsHistoryRequest());
    http(`api/backend/v2/newtifications/seen`, "GET")
      .then(response => {
        if (response.error) {
          return dispatch(notificationsHistoryRequestFailure(response.error));
        }
        return dispatch(notificationsHistoryRequestSuccess(response));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export function remoteLogout(): AppAction {
  return {
    type: "APP/REMOTE_LOGOUT"
  };
}

export function doLogout(): ThunkAction {
  return dispatch => {
    localStorage.clear();
    dispatch(logout());
  };
}

export function doRequestMe(): ThunkAction {
  return dispatch => {
    dispatch(requestMe());

    if (!localStorage.getItem("bt:accessTokenAdmin")) {
      const guest = { situation: "guest", name: "Jubialino (a)", email: "" };

      dispatch(requestMeSuccess(guest));
      return Promise.resolve(guest);
    }

    return http("api/backend/v2/admin/auth/me", "POST")
      .then(response => {
        if (response.ok) {
          return dispatch(requestMeSuccess(response));
        } else {
          localStorage.removeItem("bt:accessTokenAdmin");
          throw new Error();
        }
      })
      .catch(err => {
        if (err.message === "401") {
          dispatch(requestMeFailure());
          return Promise.reject(err.message);
        }

        dispatch(requestMeError());
        return Promise.reject(err.message);
      });
  };
}

export function closeLiveNotificationRequest(slug) {
  return {
    type: "APP/CLOSE_LIVE_NOTIFICATION",
    slug
  };
}

export function doCloseLiveNotificationRequest(slug) {
  return dispatch => {
    dispatch(closeLiveNotificationRequest(slug));
    return http(`api/backend/v2/lives/${slug}/event`, "POST", {
      event: "close_notification"
    }).catch(err => {
      console.log(err);
    });
  };
}

export function doRequestLive(user: string): ThunkAction {
  return dispatch => {
    dispatch(requestLive());
    http(`api/backend/v2/lives/user/${user}/live`, "GET")
      .then(response => {
        if (response.error) {
          return dispatch(requestliveFailure(response.error));
        }
        return dispatch(requestliveSucess(response));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export function doNewLogin(loginPath: string): ThunkAction {
  return dispatch => {
    dispatch(newLogin());
    localStorage.clear();
    dispatch(replace(loginPath));
    window.location.reload();
  };
}

export function doRetakeSession(): ThunkAction {
  return dispatch => {
    return http("api/backend/v2/auth/retake", "POST", { application: "web" })
      .then(response => {
        if (response.access_token && response.access_token !== "undefined" && response.access_token !== "Undefined") {
          localStorage.setItem("bt:accessTokenAdmin", response.access_token);
          return dispatch(requestMeSuccess(response));
        } else {
          // localStorage.removeItem("bt:accessTokenAdmin");
        }
        throw new Error();
      })
      .then(() => {
        window.location.reload();
      })
      .catch(err => {
        if (err.message === "401") {
          dispatch(requestMeFailure());
          return Promise.reject(err.message);
        }

        dispatch(requestMeError());
        return Promise.reject(err.message);
      });
  };
}

export function doRegisterTransaction(pagarmeid: string): ThunkAction {
  return dispatch => {
    dispatch(registerMe());

    const io = new IO();
    io.socket.on(`transaction${pagarmeid}`, function(msg) {
      //      dispatch(transactionUpdate(msg));
    });
  };
}

export function doPostLog(data: any): ThunkAction {
  return dispatch => {
    dispatch(errorFound());
    return http("api/backend/v2/logger/", "POST", data);
  };
}
